<div class="relative">
  <div
    [ngClass]="
      'relative z-10 lg:pt-3.5 lg:pb-3 max-lg:py-2 border-b border-b-primary-100'
    "
  >
    <div
      [ngClass]="menuOpen() ? 'translate-y-0 opacity-100' : '-translate-y-full'"
      class="absolute top-0 left-0 opacity-0 h-full w-full bg-gradient-to-r from-primary-200 via-primary-300 to-primary-400 pointer-events-none transition-transform duration-[200] delay-75"
    ></div>
    <div
      class="container flex items-center justify-between gap-5 relative z-[2]"
    >
      <a routerLink="/">
        <img app-image class="max-lg:w-24" src="images/joetLogo.png" />
      </a>
      <app-navbar [uiClass]="'max-lg:hidden'"></app-navbar>

      <button class="lg:hidden" (click)="toggleMenu()">
        <ng-icon
          size="25"
          [name]="menuOpen() ? 'heroXMark' : 'heroBars3'"
          class="text-white"
        />
      </button>
    </div>
  </div>
  <div
    [ngClass]="
      cn(
        'fixed z-[9] h-[calc(100vh-0px)] hide-scrollbar pt-[110px] pb-5 px-5 grid place-items-center overflow-y-auto bg-gradient-to-r from-primary-200 via-primary-300 to-primary-400 top-0 left-0 w-full transition-transform duration-200 lg:hidden opacity-0',
        menuOpen()
          ? 'translate-y-0 opacity-100'
          : '-translate-y-[-110%] pointer-events-none'
      )
    "
  >
    <app-navbar
      [uiClass]="'flex-col items-center justify-center text-center'"
    ></app-navbar>
  </div>
</div>
